module.exports = __webpack_public_path__ + "static/media/filter.158e5187.svg";